// Active games:
// {
//  "sp":
//     ["1pf","2pf","2wo","3pf","3wo","4pf","ams","bub","bus","bux","drg","flu","fre","jt2","jw2","jwl","maf","mah","mat","mpy","pfm","pol","pyr","s2i","s2l","s2p","sh2","so2","so3","soh","spi","spl","spp","swp","trv","wos","xwo","zoo"],
//  "mp":
//     ["bel","bgm","dko","hts","kla","kno","mau","mbs","mjj","rom","ruk","rum","ska","tar","wiz"]
// }

const supportedGametypes =
  // official supported gametypes:
  [
    '2wo',
    '3wo',
    'jt2',
    'sh2',
    'so3',
    's2l',
    's2i',
    's2p',
    'jwl',
    'ams',
    'bub',
    'bus',
    'bux',
    'drg',
    'flu',
    'fre',
    'jw2',
    'maf',
    'mah',
    'mpy',
    'pfm',
    '1pf',
    '2pf',
    '3pf',
    '4pf',
    'pol',
    's2p',
    'mat',
    'so2',
    'wos',
    'pyr',
    'soh',
    'spi',
    'spl',
    'spp',
    'swp',
    'trv',
    'xwo',
    'zoo',
    'bel',
    'bel_basic',
    'bel_annonces',
    'bel_contree',
    'bel_coinche',
    'bgm',
    'dko',
    'dko_official',
    'kla',
    'kla_basic',
    'mau',
    'mau_official',
    'tar',
    'tar_formal',
    'ska',
    'ska_official',
    'ska_kneipenskat',
    'rom',
    'rom_official',
    'hts',
    'kno',
    'mbs',
    'mjj',
    'ruk',
    'rum',
    'wiz',
    'wiz_official',
    'fr2',
    'jj2'
  ]
// all gameduell gametypes
const gametypes = [
  // 'lab',
  // 'tau',
  'spp',
  'fre',
  'maf',
  // 'gos',
  // 'sdk',
  // 'mag',
  'spi',
  // 'sol',
  'so2',
  // 'qbu',
  // 'dar',
  // 'bil',
  'bgm',
  // 'prt',
  // 'cpt',
  'mah',
  'drg',
  'soh',
  'spl',
  // 'jet',
  // 'tr2',
  // 'kdo',
  'mpy',
  'mau',
  'mau_official',
  'hts',
  // 'mpp',
  'zoo',
  'bub',
  'pol',
  'flu',
  'bus',
  // 'ctc',
  // 'sen',
  'ams',
  // 'mps',
  // 'pbx',
  // 'mdn',
  // 'hid',
  'wiz',
  'wiz_official',
  'jw2',
  'jwl',
  'mjj',
  // 'cpy',
  'bux',
  'mbs',
  'dko',
  'dko_official',
  'bel',
  'bel_basic',
  'bel_annonces',
  'bel_contree',
  'bel_coinche',
  'kla',
  'kla_basic',
  'kno',
  // 'mus',
  'pfm',
  'pyr',
  // 'qui',
  'rom',
  'rom_official',
  'ruk',
  'rum',
  'ska',
  'ska_official',
  'ska_kneipenskat',
  // 'sss',
  'tar',
  'tar_formal',
  // 'wob',
  'wos',
  'xwo',
  'jt2',
  'so3',
  'sh2',
  's2l',
  's2i',
  's2p',
  '1pf',
  '2pf',
  '2wo',
  '3pf',
  '3wo',
  '4pf',
  'mat',
  'swp',
  'trv',
  'fr2',
  'jj2'
]
export { gametypes, supportedGametypes }
